import {
  AmpClient,
  AmpRegistrationStatus,
} from "@redotech/redo-marketing-core-common/amp-registration-definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const checkAmpRegistrationStatus = {
  name: "checkAmpRegistrationStatus" as const,
  input: z.object({ emailAddress: z.string() }),
  output: z.object({
    [AmpClient.GMAIL]: z.union([
      createEnum(AmpRegistrationStatus),
      z.undefined(),
    ]),
    [AmpClient.YAHOO]: z.union([
      createEnum(AmpRegistrationStatus),
      z.undefined(),
    ]),
  }),
};
